/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import classname from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';

import { ICittaProductSkuData } from './citta-product-sku.data';
import { ICittaProductSkuProps } from './citta-product-sku.props.autogenerated';

export interface ICittaProductSkuViewProps extends ICittaProductSkuProps<ICittaProductSkuData> {
    ProductSkuContainer: IModuleProps;
    SkuTitleTextNode: INodeProps;
    ProductSkuNode: INodeProps;
}

/**
 *
 * CittaProductSku component
 * @extends {React.PureComponent<ICittaProductSkuProps<ICittaProductSkuData>>}
 */
@observer
class CittaProductSku extends React.PureComponent<ICittaProductSkuProps<ICittaProductSkuData>> {
    public render(): JSX.Element | null {
        let content: ICittaProductSkuData;

        try {
            content = this.props.data;
        } catch(e) {
            this.props.telemetry.error(`Something went wrong -----${e}`);
            return null;
        }

        const productSku = content && content.product && content.product.result && content.product.result.ItemId;
        const skuTitleText = this.props.config && this.props.config.skuTitleText ? this.props.config.skuTitleText : 'SKU:';
        const className = this.props.config && this.props.config.className ? this.props.config.className : '';
        if (productSku) {
            const productSkuViewProps: ICittaProductSkuViewProps = {
                ...(this.props as ICittaProductSkuProps<ICittaProductSkuData>),
                ProductSkuContainer: {
                    moduleProps: this.props,
                    className: classname('product-sku', className),
                },
                SkuTitleTextNode: {
                    className: 'product-sku-title',
                    children: skuTitleText
                },
                ProductSkuNode: {
                    className: 'product-sku-id',
                    children: productSku
                }
            };
            return this.props.renderView(productSkuViewProps) as React.ReactElement;
        }
        return null;
    }
}

export default CittaProductSku;
